{
  "v9.exceptions.action.platform.billing_exception_cancelled": "Exception annulée",
  "v9.exceptions.action.platform.billing_exception_countersign_refused": "Seconde signature refusée",
  "v9.exceptions.action.platform.billing_exception_countersigned": "Contresignée",
  "v9.exceptions.action.platform.billing_exception_granted": "Exception accordée",
  "v9.exceptions.aide.confirmation": "Votre mot de passe confirme votre identité ; il n’est pas conservé.",
  "v9.exceptions.aide.date_effet": "Par défaut, la prochaine échéance.",
  "v9.exceptions.aide.motif": "{{n}} caractères au moins.",
  "v9.exceptions.aide.operations_en_cours": "Les opérations en cours restent dans la devise d'origine.",
  "v9.exceptions.aide.pieces": "PDF, PNG ou JPEG, 5 Mo au plus par pièce.",
  "v9.exceptions.annuler": "Annuler",
  "v9.exceptions.annuler_exception": "Annuler l'exception",
  "v9.exceptions.champ.complement": "Complément",
  "v9.exceptions.champ.confirmation": "Mot de passe (ré-authentification)",
  "v9.exceptions.champ.date_effet": "Date d'effet souhaitée",
  "v9.exceptions.champ.devise": "Devise",
  "v9.exceptions.champ.devise_cible": "Devise cible",
  "v9.exceptions.champ.duree": "Durée (jours)",
  "v9.exceptions.champ.facture": "Facture concernée (identifiant)",
  "v9.exceptions.champ.mode": "Mode de paiement",
  "v9.exceptions.champ.montant": "Montant",
  "v9.exceptions.champ.motif": "Motif",
  "v9.exceptions.champ.motif_annulation": "Motif de l'annulation",
  "v9.exceptions.champ.motif_seconde": "Motif (facultatif)",
  "v9.exceptions.champ.nature": "Nature de la demande",
  "v9.exceptions.champ.palier": "Palier",
  "v9.exceptions.champ.periodicite": "Périodicité",
  "v9.exceptions.champ.pieces": "Pièces jointes",
  "v9.exceptions.champ.prix": "Prix",
  "v9.exceptions.champ.validite": "Valable jusqu'au",
  "v9.exceptions.code.CONFIRMATION_IDENTITE_ECHOUEE": "La confirmation d'identité a échoué.",
  "v9.exceptions.code.CONFIRMATION_IDENTITE_REQUISE": "Confirmez votre identité avant cette action.",
  "v9.exceptions.code.CONTEXTE_INCOMPLET": "Aucune organisation dans la session.",
  "v9.exceptions.code.CONTRESIGNATURE_NON_REQUISE": "Aucune seconde signature n'est attendue pour cette exception.",
  "v9.exceptions.code.DELAI_DE_REFLEXION_EN_COURS": "Auto-approbation : le délai de réflexion court encore.",
  "v9.exceptions.code.DEMANDE_CLOSE": "Cette demande est close.",
  "v9.exceptions.code.DEMANDE_DEJA_ACCORDEE": "Cette demande est accordée : elle ne peut plus être retirée.",
  "v9.exceptions.code.DEMANDE_IDENTIQUE_DEJA_OUVERTE": "Une demande de même nature, pour la même facture, est déjà ouverte.",
  "v9.exceptions.code.DEVIS_EXPIRE": "Ce devis a expiré.",
  "v9.exceptions.code.DEVIS_REMPLACE": "Cette révision du devis est remplacée par une plus récente.",
  "v9.exceptions.code.DROIT_NON_TENU": "Vous ne tenez pas le droit requis.",
  "v9.exceptions.code.EXCEPTION_DEJA_EXECUTEE": "Cette exception est exécutée, même partiellement : régularisez-la au lieu de l'annuler.",
  "v9.exceptions.code.IDEMPOTENCY_CONFLICT": "Cette demande a déjà été envoyée avec un autre contenu.",
  "v9.exceptions.code.MOYEN_DE_PAIEMENT_REQUIS": "Ce devis prévoit un débit : ajoutez d'abord un moyen de paiement.",
  "v9.exceptions.code.PAIEMENT_REFUSE": "Le paiement a été refusé par le prestataire.",
  "v9.exceptions.code.PALIER_SUR_MESURE_COLLISION": "Le palier sur mesure ne peut pas être créé : contactez la plateforme.",
  "v9.exceptions.code.PRESTATAIRE_INDISPONIBLE": "Le prestataire de paiement n'est pas joignable : réessayez plus tard.",
  "v9.exceptions.code.PROPRIETAIRE_SEUL": "Réservé au propriétaire de l'organisation.",
  "v9.exceptions.code.RESOURCE_UNAVAILABLE": "Élément introuvable.",
  "v9.exceptions.code.SANS_SESSION": "Session expirée : reconnectez-vous.",
  "v9.exceptions.code.VALIDATION_ERROR": "La saisie est invalide : vérifiez le motif, la devise, la date et les pièces.",
  "v9.exceptions.code.VALIDATION_PAR_UN_TIERS": "La personne qui a demandé ne contresigne pas : un autre administrateur de la plateforme valide.",
  "v9.exceptions.code.VERSION_CONFLICT": "Modifié entre-temps : rechargez la page avant de réessayer.",
  "v9.exceptions.complement.ajoute": "Complément ajouté à l'historique.",
  "v9.exceptions.complement.ajouter": "Ajouter le complément",
  "v9.exceptions.demandeur": "Demandé par {{qui}}",
  "v9.exceptions.devis.accepte": "Devis accepté : la souscription est enregistrée (changement {{changement}}).",
  "v9.exceptions.devis.accepter": "Accepter le devis",
  "v9.exceptions.devis.decliner": "Décliner le devis",
  "v9.exceptions.devis.proposition": "Révision {{n}} : {{montant}}, {{periodicite}}",
  "v9.exceptions.devis.quotas": "Quotas du devis",
  "v9.exceptions.devis.revision_n": "Révision {{n}}",
  "v9.exceptions.devis.validite": "Valable jusqu'au {{date}}",
  "v9.exceptions.devis.vide": "Aucune proposition pour le moment.",
  "v9.exceptions.ecran.dialogue-demander-exception-facturation": "Demander une exception de facturation à la plateforme",
  "v9.exceptions.ecran.dialogue-exception-facturation": "Accorder une exception de facturation",
  "v9.exceptions.ecran.organisation-demande-exception-fiche": "Suivi d'une demande d'exception de facturation",
  "v9.exceptions.ecran.plateforme-exception-facturation-fiche": "Suivi d'une exception de facturation",
  "v9.exceptions.en_cours": "En cours…",
  "v9.exceptions.envoyee": "Demande envoyée à la plateforme.",
  "v9.exceptions.envoyer": "Envoyer la demande",
  "v9.exceptions.erreur.accepter": "Le devis n'a pas pu être accepté.",
  "v9.exceptions.erreur.accorder": "L'exception n'a pas pu être enregistrée.",
  "v9.exceptions.erreur.annuler": "L'exception n'a pas pu être annulée.",
  "v9.exceptions.erreur.completer": "Le complément n'a pas pu être ajouté.",
  "v9.exceptions.erreur.contresigner": "La seconde signature n'a pas pu être enregistrée.",
  "v9.exceptions.erreur.decliner": "Le devis n'a pas pu être décliné.",
  "v9.exceptions.erreur.envoyer": "La demande n'a pas pu être envoyée.",
  "v9.exceptions.erreur.refuser": "Le refus n'a pas pu être enregistré.",
  "v9.exceptions.erreur.retirer": "La demande n'a pas pu être retirée.",
  "v9.exceptions.etat.accordee": "Accordée",
  "v9.exceptions.etat.chargement": "Chargement de {{quoi}}…",
  "v9.exceptions.etat.devis_accepte": "Devis accepté",
  "v9.exceptions.etat.devis_decline": "Devis décliné",
  "v9.exceptions.etat.devis_expire": "Devis expiré",
  "v9.exceptions.etat.devis_propose": "Devis proposé",
  "v9.exceptions.etat.en_instruction": "En instruction",
  "v9.exceptions.etat.envoyee": "Envoyée",
  "v9.exceptions.etat.erreur": "Impossible de charger {{quoi}}.",
  "v9.exceptions.etat.refus": "Vous n'avez pas accès à ces informations.",
  "v9.exceptions.etat.refusee": "Refusée",
  "v9.exceptions.etat.retiree": "Retirée",
  "v9.exceptions.etat.vide": "Rien à afficher.",
  "v9.exceptions.etat_exception.annulee": "Annulée",
  "v9.exceptions.etat_exception.demandee": "Demandée",
  "v9.exceptions.etat_exception.echouee": "Échouée chez le prestataire",
  "v9.exceptions.etat_exception.en_attente_de_seconde_signature": "En attente de seconde signature",
  "v9.exceptions.etat_exception.en_attente_du_prestataire": "En attente du prestataire",
  "v9.exceptions.etat_exception.executee": "Exécutée",
  "v9.exceptions.etat_exception.partiellement_executee": "Partiellement exécutée",
  "v9.exceptions.etat_exception.refusee_par_le_second_signataire": "Refusée par le second signataire",
  "v9.exceptions.etat_exception.regularisee": "Régularisée",
  "v9.exceptions.etat_revision.acceptee": "acceptée",
  "v9.exceptions.etat_revision.declinee": "déclinée",
  "v9.exceptions.etat_revision.en_vigueur": "en vigueur",
  "v9.exceptions.etat_revision.expiree": "expirée",
  "v9.exceptions.etat_revision.remplacee": "remplacée par une révision",
  "v9.exceptions.evenement.complement": "Complément",
  "v9.exceptions.evenement.piece": "Pièce jointe",
  "v9.exceptions.evenement.reponse": "Réponse de la plateforme",
  "v9.exceptions.evenement.retrait": "Demande retirée",
  "v9.exceptions.exception.creee": "Exception enregistrée.",
  "v9.exceptions.facture_n": "facture {{facture}}",
  "v9.exceptions.historique.vide": "Aucun événement.",
  "v9.exceptions.invalide.complement": "Le complément est vide.",
  "v9.exceptions.invalide.date": "La date d'effet est passée.",
  "v9.exceptions.invalide.devis": "Le devis demande un prix, une validité et des quotas entiers.",
  "v9.exceptions.invalide.devise": "Choisissez une devise différente de la devise actuelle.",
  "v9.exceptions.invalide.duree": "La durée est un nombre de jours positif.",
  "v9.exceptions.invalide.essai": "L'essai demande un palier et une durée positive.",
  "v9.exceptions.invalide.format": "Format de pièce non supporté (PDF, PNG, JPEG).",
  "v9.exceptions.invalide.montant": "Montant invalide : deux décimales au plus.",
  "v9.exceptions.invalide.motif": "Le motif doit compter 15 caractères au moins.",
  "v9.exceptions.invalide.motif_annulation": "Le motif de l'annulation est obligatoire.",
  "v9.exceptions.invalide.palier": "Choisissez le palier souhaité.",
  "v9.exceptions.invalide.volumineuse": "Pièce trop volumineuse : 5 Mo au plus.",
  "v9.exceptions.mode.debit": "Débit par le prestataire",
  "v9.exceptions.mode.virement": "Virement sur facture",
  "v9.exceptions.montant_souhaite": "Montant souhaité : {{montant}}",
  "v9.exceptions.moyen.ajouter": "Ajouter un moyen de paiement",
  "v9.exceptions.moyen.facultatif": "Paiement sur facture par virement : aucun moyen requis.",
  "v9.exceptions.moyen.obligatoire": "Ce devis prévoit un débit : un moyen de paiement est obligatoire.",
  "v9.exceptions.moyen.utilise": "Moyen utilisé pour la souscription : {{moyen}}",
  "v9.exceptions.nature.avoir": "Avoir",
  "v9.exceptions.nature.changement_de_devise_pour_les_operations_futures": "Changement de devise pour les opérations futures",
  "v9.exceptions.nature.devis_palier_sur_mesure": "Devis pour un palier sur mesure",
  "v9.exceptions.nature.essai_d_un_palier_payant": "Essai d'un palier payant",
  "v9.exceptions.nature.geste_commercial": "Geste commercial",
  "v9.exceptions.nature.prolongation": "Prolongation",
  "v9.exceptions.nature.prolongation_d_un_essai_en_cours": "Prolongation d'un essai en cours",
  "v9.exceptions.nature.prolongation_du_delai_de_paiement": "Prolongation du délai de paiement",
  "v9.exceptions.nature.regularisation_d_une_exception_partielle": "Régularisation d'une exception partielle",
  "v9.exceptions.nature.remboursement": "Remboursement",
  "v9.exceptions.periodicite.annuelle": "annuelle",
  "v9.exceptions.periodicite.mensuelle": "mensuelle",
  "v9.exceptions.plateforme.accorder": "Enregistrer l'exception",
  "v9.exceptions.plateforme.demande_jointe": "En réponse à la demande {{demande}} du propriétaire.",
  "v9.exceptions.plateforme.execution": "Exécutée par le prestataire de paiement quand aucune seconde signature n'est requise.",
  "v9.exceptions.plateforme.origine": "Régularise l'exception {{exception}}.",
  "v9.exceptions.plateforme.palier_un_seul_chemin": "Le palier d'une organisation ne change que depuis sa fiche (un seul chemin).",
  "v9.exceptions.plateforme.revision_remplace": "Une nouvelle proposition remplace la révision en vigueur : une seule est acceptable à la fois.",
  "v9.exceptions.plateforme.seconde_non_requise": "Aucune seconde signature : geste commercial ou prolongation.",
  "v9.exceptions.plateforme.seconde_requise": "Seconde signature requise par un autre administrateur de la plateforme.",
  "v9.exceptions.qui_instruit.nominal": "La plateforme instruit votre demande et vous répond ici.",
  "v9.exceptions.qui_instruit.seconde_signature": "La plateforme instruit votre demande ; un remboursement ou un avoir exige une seconde signature.",
  "v9.exceptions.quoi.demande": "la demande",
  "v9.exceptions.quoi.exception": "l'exception",
  "v9.exceptions.quota.ai_calls_per_day": "Appels IA par jour",
  "v9.exceptions.quota.document_size_mb": "Taille par document (Mo)",
  "v9.exceptions.quota.documents_count": "Documents",
  "v9.exceptions.quota.requests_per_minute": "Requêtes par minute",
  "v9.exceptions.quota.tokens_per_day": "Jetons par jour",
  "v9.exceptions.raison.aucun_moyen": "Ajoutez d’abord un moyen de paiement : ce devis prévoit un débit.",
  "v9.exceptions.raison.auteur_de_la_demande": "Vous avez demandé cette exception : un autre administrateur de la plateforme la contresigne.",
  "v9.exceptions.raison.deja_accordee": "Demande accordée : elle ne peut plus être retirée.",
  "v9.exceptions.raison.deja_executee": "Exception exécutée : régularisez-la au lieu de l’annuler.",
  "v9.exceptions.raison.delai_de_reflexion": "Seul super-administrateur : le délai de réflexion court encore.",
  "v9.exceptions.raison.demande_close": "Proposition close.",
  "v9.exceptions.raison.devis_expire": "Ce devis a expiré.",
  "v9.exceptions.raison.facture_a_venir": "La fiche des factures arrive avec le lot des factures.",
  "v9.exceptions.raison.moyen_a_venir": "L'ajout d'un moyen de paiement arrive avec le lot de l'abonnement.",
  "v9.exceptions.raison.partiellement_executee": "Exécutée en partie : régularisez le restant.",
  "v9.exceptions.rapprochement.ecart": "Écart au rapprochement",
  "v9.exceptions.rapprochement.non_rapproche": "Non rapprochée",
  "v9.exceptions.rapprochement.orphelin": "Événement orphelin",
  "v9.exceptions.rapprochement.rapproche": "Rapprochée",
  "v9.exceptions.reessayer": "Réessayer",
  "v9.exceptions.reference": "Référence du prestataire : {{reference}}",
  "v9.exceptions.reference.absente": "Aucune référence du prestataire.",
  "v9.exceptions.regularisations.vide": "Aucune régularisation.",
  "v9.exceptions.regulariser": "Régulariser",
  "v9.exceptions.reponse.accordee": "Accordée par la plateforme.",
  "v9.exceptions.reponse.en_attente": "En attente de la réponse de la plateforme.",
  "v9.exceptions.reponse.refusee": "Refusée par la plateforme : {{motif}}",
  "v9.exceptions.retirer": "Retirer la demande",
  "v9.exceptions.retour": "Retour à l'abonnement",
  "v9.exceptions.retour_organisation": "Retour à la facturation de l'organisation",
  "v9.exceptions.sans_montant": "Sans montant",
  "v9.exceptions.seconde.contresigner": "Contresigner",
  "v9.exceptions.seconde.refuser": "Refuser la seconde signature",
  "v9.exceptions.seconde.seul_super_administrateur": "Seul super-administrateur : auto-approbation avec ré-authentification et délai de réflexion, mentionnée au journal.",
  "v9.exceptions.section.devis": "Devis",
  "v9.exceptions.section.historique": "Historique",
  "v9.exceptions.section.regularisations": "Régularisations",
  "v9.exceptions.section.seconde_signature": "Seconde signature",
  "v9.exceptions.section.suivi": "Compléter ou retirer",
  "v9.exceptions.signataires.auto_approuve": "Auto-approuvée (seul super-administrateur)",
  "v9.exceptions.signataires.contresignee": "Contresignée par {{qui}}",
  "v9.exceptions.signataires.en_attente": "Second signataire attendu",
  "v9.exceptions.signataires.non_requis": "Seconde signature non requise",
  "v9.exceptions.voir_facture": "Voir la facture"
}
